import { useForm } from 'react-final-form';

export function useFormValues<T>(): T {
  const form = useForm<T>();

  return form.getState().values;
}
